export const CARE_SCOUT_PRICING_PLAN_IMAGE_URL =
  'react-assets/carescout/cs-price-plan.png';
